import type { AfterViewInit, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getEnv } from '@env';
import { NzMessageService } from 'ng-zorro-antd/message';

import type { InviteBody, Result } from './type';
@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.less'],
  standalone: false,
})
export class ShareComponent implements AfterViewInit, OnInit {
  env = getEnv();
  userMobile = '';
  count = 0;
  captcha = '';
  inviterUnionId: any = '';
  isWX = false;
  interval$: any;
  isCodeSent = false;
  private http: HttpClient = inject(HttpClient);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private msg: NzMessageService = inject(NzMessageService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  ngOnInit(): void {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/micromessenger/i.test(userAgent)) {
      this.isWX = true;
    }
  }
  ngAfterViewInit(): void {
    this.inviterUnionId = this.route.snapshot.queryParams['id'];
    // console.log(this.inviterUnionId, 'this.inviterUnionId');

    if (!this.inviterUnionId) alert('页面异常,请重新打开');
    // 1.判断window.onresize前后大小，间接判断软键盘弹出，在对页面布局做处理，如改变position或设置容易大小为定值
    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    const boxHeight = document.getElementsByClassName('box')[0].clientHeight;

    window.onresize = function () {
      const nowClientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (clientHeight > nowClientHeight) {
        //键盘弹出的事件处理
        console.log('键盘弹出的事件处理', clientHeight);
        document.body.style.height = clientHeight - 29 + 'px';
      } else {
        document.body.style.height = boxHeight + 'px';
        console.log('键盘收起的事件处理', clientHeight);
        console.log('键盘收起的事件处理', boxHeight);
        //键盘收起的事件处理
      }
    };
  }
  // getCaptcha(): void {
  //   if (this.userMobile) {
  //     this.userMobile.markAsDirty({ onlySelf: true });
  //     this.userMobile.updateValueAndValidity({ onlySelf: true });
  //     return;
  //   }
  //   this.authService.getSmsCode(this.mobile.value).subscribe((res) => {
  //     if (res.code !== '00000') {
  //       this.msg.warning(res.msg);
  //       return;
  //     }
  //     this.msg.success('获取验证码成功,请到手机上查看');
  //     console.log('获取验证码', res);
  //   });
  //   this.count = 59;
  //   this.interval$ = setInterval(() => {
  //     this.count -= 1;
  //     this.cdr.detectChanges();
  //     if (this.count <= 0) {
  //       clearInterval(this.interval$);
  //     }
  //   }, 1000);
  // }
  sendVerificationCode() {
    this.http.post<Result>(`${this.env.baseUrl}eliboo-app-boot/sms-code`, this.userMobile).subscribe((res) => {
      const reg = /^1[0-9]{10}$/; //验证规则
      if (!this.userMobile) {
        alert('请先输入手机号');
        return;
      }
      if (!reg.test(this.userMobile)) {
        alert('请输入正确的手机号');
        return;
      }
      if (res.code !== '00000') {
        this.msg.warning(res.msg);
        return;
      }
      this.msg.success('获取验证码成功,请到手机上查看');
      console.log('获取验证码', res);
    });
    this.count = 59;
    this.interval$ = setInterval(() => {
      this.count -= 1;
      this.cdr.detectChanges();
      if (this.count <= 0) {
        clearInterval(this.interval$);
      }
    }, 1000);
  }
  submit() {
    if (!this.inviterUnionId) {
      alert('页面异常,请重新打开');
      return;
    }
    const reg = /^1[0-9]{10}$/; //验证规则
    if (!this.userMobile) {
      alert('请先输入手机号');
      return;
    }
    if (!reg.test(this.userMobile)) {
      alert('请输入正确的手机号');
      return;
    }
    const body: InviteBody = {
      inviterUnionId: this.inviterUnionId,
      userMobile: this.userMobile,
      captcha: this.captcha,
    };
    const api = this.http.post<Result>(`${this.env.baseUrl}eliboo-app-boot/app-api/v1/userInviter/record`, body);
    api.subscribe(
      (res) => {
        window.open(this.env.apkUrl, '_self');
        if (res.code === '00000' && res.data == true) {
          alert('下载中，请注意查收');
        } else {
          alert(res.msg);
        }
      },
      (error) => {
        // window.open(environment.apkUrl, '_self');
        console.log('22222', error.error.msg);
        this.msg.error(error.error.msg);
      },
    );
  }
}
